import { buildStandardHeaders, request } from '../util/network';
import type { OurContext } from '../context';

export type Status =
  'ACCEPTED' | 'REJECTED' | 'FAILED' | 'TIMEOUT' | 'ERROR' | 'PENDING' | 'SUBMITTED';
type StatusResponse = {
  status: Status;
};

export async function pollStatus(context: OurContext): Promise<Status> {
  if (!context.claims) {
    return 'ERROR';
  }
  const headers = {
    'Cache-Control': 'no-store',
    Pragma: 'no-cache',
    ...buildStandardHeaders(context.apiSubscriptionId, context.apiAuth),
  };
  const response = await request(context.claims.url, 'GET', headers, undefined, 1);
  if (
    response?.status === 200 &&
    response.headers.get('Content-Type')?.indexOf('application/json') !== -1
  ) {
    const json: StatusResponse = await response.json();
    return json.status;
  } else if (response?.status === 401) {
    return 'TIMEOUT';
  }
  return 'ERROR';
}
